import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { FilterMatchMode } from 'primereact/api';
import { useNavigate } from "react-router-dom";
import CommonConfig from "../../../utils/constant";
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import { useCatchResponse } from '../../../utils/useCatchResponse';


const Examination = () => {
    const { catchResponse } = useCatchResponse();
    const [searchTerm, setSearchTerm] = useState("");
    const [activeTab, setActiveTab] = useState(0);
    const [securityUserID, setSecurityUserID] = useState("");
    const navigate = useNavigate();
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [examScheduleOnGoingMarksList, setExamScheduleOnGoingMarksList] = useState([]);
    const [examScheduleCompletedMarksList, setExamScheduleCompletedMarksList] = useState([]);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ClassName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };
    const filteredExams = (activeTab === 1 ? examScheduleCompletedMarksList : examScheduleOnGoingMarksList).filter(exam =>
        exam?.Class?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
        exam?.Subject?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
        exam?.ExamType?.toLowerCase()?.includes(searchTerm?.toLowerCase())
    );

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetExamScheduleList(loginData?._id, loginData?.CreatedBy);
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const GetExamScheduleList = async (id, schId) => {
        try {
            let data = {
                UserID: id,
                SchoolId: schId
            }
            Loader.show();
            await api.post(APIConstant.path.GetExamScheduleMarksList, data).then(async response => {
                let res = response;
                if (res.success) {
                    var onGoingList = res?.data.filter(x => x?.IsAllow === true);
                    var completeList = res?.data.filter(x => x?.IsAllow === false);
                    setExamScheduleOnGoingMarksList(onGoingList);
                    setExamScheduleCompletedMarksList(completeList);
                }
                Loader.hide();
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const checkedTemplate = (rowData) => (
        <span style={{ color: "green" }}>{rowData?.Checked}</span>
    );

    const actionTemplate = (rowData) => (
        <Button label={!rowData?.IsAllow ? "View" : "Configure"} onClick={(e) => navigate('/examination-marks', { state: { className: rowData?.ClassName, subjectName: rowData?.SubjectName, classId: rowData?.ClassId, examId: rowData?.ExamId, subjectId: rowData?.SubjectId, termId: rowData?.TermId, isAllow: rowData?.IsAllow } })} />
    );

    const srNoBodyTemplate = (data, props) => {
        return props?.rowIndex + 1;
    };

    return (
        <div className='wayment-owner-dashboard'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-book"></i>
                    <h2>Examination</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                </div>
            </div>
            <div className="e-tab-main">
            <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)} style={{ padding: '0px' }}>
                <TabPanel header="Ongoing">
                    <DataTable value={filteredExams} paginator
                        rows={rows}
                        first={first}
                        responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        onPage={onPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 175px)'
                        size='small'
                    >
                        <Column header="Sr No" body={srNoBodyTemplate} style={{ minWidth: '6rem', maxWidth: '6rem' }} />
                        <Column field="ExamType" header="Exam Name" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column field="ClassName" header="Class" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column field="SectionName" header="Section" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column field="SubjectName" header="Subject Name" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column field="TermName" header="Term Name" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column field="TotalStudents" header="Total Students" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column header="Checked" body={checkedTemplate} style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column header='Action' body={actionTemplate} headerStyle={{ width: '100%' }} />
                    </DataTable>
                </TabPanel>
                <TabPanel header="Completed">
                    <DataTable value={filteredExams} paginator
                        rows={rows}
                        first={first}
                        responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        onPage={onPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 175px)'
                        size='small'
                    >
                        <Column header="Sr No" body={srNoBodyTemplate} style={{ minWidth: '6rem', maxWidth: '6rem' }} />
                        <Column field="ExamType" header="Exam Type" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column field="ClassName" header="Class" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column field="SubjectName" header="Subject" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column field="TermName" header="Term Name" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column field="TotalStudents" header="Total Students" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column header="Checked" body={checkedTemplate} style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column header='Action' body={actionTemplate} headerStyle={{ width: '100%' }}/>
                    </DataTable>
                </TabPanel>
            </TabView>
            </div>
        </div>
    );
};

export default Examination;
